module.exports = __webpack_public_path__ + "img/home1.71bb2030.jpg";